import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { FaUser, FaTrophy, FaCog, FaSignOutAlt } from 'react-icons/fa';
import { IoSettings } from 'react-icons/io5';
import Avatar from 'components/ui/avatar';
import { getProfileImage } from 'utils/helpers';
import logoHeader from '../../assets/img/logo_header.png';
import './styles.scss';

interface HeaderProps {
  className?: string;
}

export function Header({ className = '' }: HeaderProps) {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleLogout = () => {
    signOut();
    navigate('/');
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  // Função para verificar se a rota está ativa
  const isActiveRoute = (path: string) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <header className={`app-header ${className}`}>
      <div className="header-container">
        {/* Logo */}
        <div className="header-logo">
          <Link to="/" onClick={closeDropdown}>
            <img src={logoHeader} alt="Rankifier" />
          </Link>
        </div>

        {/* Navigation Menu */}
        {user && (
          <nav className="header-nav">
            
            {/* Ranking */}
            <Link 
              to="/ranking" 
              className={`nav-item ${isActiveRoute('/ranking') || isActiveRoute('/') ? 'nav-item-active' : ''}`}
              onClick={closeDropdown}
            >
              <div className="nav-icon">
                <FaTrophy />
              </div>
              <span>Ranking</span>
            </Link>
            
            {/* Perfil */}
            <Link 
              to="/perfil" 
              className={`nav-item ${isActiveRoute('/perfil') ? 'nav-item-active' : ''}`}
              onClick={closeDropdown}
            >
              <div className="nav-icon">
                <FaUser />
              </div>
              <span>Perfil</span>
            </Link>


            {/* Configurações com Dropdown */}
            <Link 
              to="/configuracoes" 
              className={`nav-item ${isActiveRoute('/configuracoes') ? 'nav-item-active' : ''}`}
              onClick={closeDropdown}
            >
              <div className="nav-icon">
                <IoSettings />
              </div>
              <span>Configurações</span>
            </Link>

            {/* User Avatar com Dropdown */}
            <div className="nav-dropdown">
              <div className="nav-item user-avatar" onClick={toggleDropdown}>
                <Avatar 
                  src={getProfileImage(user)}
                  name={user?.name}
                  size="md"
                  className="header-avatar"
                />
              </div>

              {isDropdownOpen && (
                <div className="dropdown-menu">
                  <button onClick={handleLogout}>
                    <FaSignOutAlt />
                    Sair
                  </button>
                </div>
              )}
            </div>
          </nav>
        )}
      </div>

      {/* Overlay for closing dropdown */}
      {isDropdownOpen && <div className="dropdown-overlay" onClick={closeDropdown} />}
    </header>
  );
}
